import uuid from "react-uuid";
import { SESSION_ID, getSessionFromStorage, setAuthKeys } from "utils/localStorageUtils";
import { getUrlCountryPath } from "utils/urlUtils";
import { CREATE_TOKEN_URL } from "./paths";
import { authPostQuery } from "api/AxiosQueries";
import { getAuthHeaderConfig } from "utils/authUtils";
import { AppConfig } from "AppConfig";
import { useDispatch } from "react-redux";

const {
  audience,
} = AppConfig.authApi.hca

export const HCA_RETURN_URL = 'hca-return-url';

const hcaAuth = {
  hcaRegisterRedirect: () => {
    const sessionId = uuid()

    setAuthKeys({ key: SESSION_ID, payload: sessionId })
    setAuthKeys({ key: HCA_RETURN_URL, payload: window.location.href});
    window.history.replaceState(null, "Redirecting...", [window.location.origin, getUrlCountryPath()].join('/'));
    window.hcaSdk && window.hcaSdk.signUp();
  },
  hcaLoginRedirect: () => {
    const sessionId = uuid()

    setAuthKeys({ key: SESSION_ID, payload: sessionId })
    setAuthKeys({ key: HCA_RETURN_URL, payload: window.location.href});
    window.history.replaceState(null, "Redirecting...", [window.location.origin, getUrlCountryPath()].join('/'));
    window.hcaSdk && window.hcaSdk.signIn();
  },
  createUserToken: ({ taxonomyRegistration, accessToken }) => {

    const sessionId = getSessionFromStorage()
    // const url = `${CREATE_TOKEN_URL}?sessionId=${sessionId}&additionalInfo=${JSON.stringify(taxonomyRegistration).replaceAll('&','%26')}`
    const url = `${CREATE_TOKEN_URL}`
    return authPostQuery({ url, data: { accessToken  }, config: getAuthHeaderConfig({ audienceUrl: audience }) }).then((response) => response)

  },
  hcaLogout: () => {
    window.history.replaceState(null, "Redirecting...", [window.location.origin, getUrlCountryPath()].join('/').concat("?action=logged-out"));
    window.hcaSdk && window.hcaSdk.signOut();
  }
};

export { hcaAuth };
